import React from 'react';

interface ModalProps {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  maxWidth?: number;
  /** When false, clicking the backdrop does not close (e.g. while a request is in flight). */
  dismissable?: boolean;
}

/** App-styled modal (reuses .modal-overlay / .modal / .modal-title). */
const Modal: React.FC<ModalProps> = ({ title, onClose, children, maxWidth = 520, dismissable = true }) => (
  <div className="modal-overlay" onClick={() => { if (dismissable) onClose(); }}>
    <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth }}>
      <h2 className="modal-title">{title}</h2>
      {children}
    </div>
  </div>
);

export default Modal;
